import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import colors, { withOpacity } from '@front/common/src/utils/colors';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import Title from '@front/web-ui/src/components/base-text/variants/title';

import { useNavigateHistoryWithQuery } from '../../hooks/use-navigate-history-with-query';
import { getRoute } from '../../routes/routes';
import GradientBackgroundWrapper from '../../components/gradient-background-wrapper/gradient-background-wrapper';

const t = translate('screens.not_qualified');

const StyledGradientWrapper = styled(GradientBackgroundWrapper)`
  padding: 0 20px;
`;

const StyledTitle = styled(Title.XL)`
  margin-top: 100px;
`;

const ContentCard = styled.div`
  margin-top: 40px;
  padding: 20px;
  background-color: ${withOpacity(colors.white100, 0.5)};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const NotQualified = () => {
  const location = useLocation();
  const { historyPushWithQuery } = useNavigateHistoryWithQuery();
  const searchQueryParams = new URLSearchParams(location.search);
  const reason = searchQueryParams.get('reason');

  if (!reason) {
    historyPushWithQuery(getRoute('revenue_simulator'));
    return null;
  }

  const shouldDisplayContent = [
    'residence_permit_expired',
    'residence_permit_not_accepted',
    'not_enough_volume',
    'out_of_area',
  ].includes(reason);

  return (
    <StyledGradientWrapper testID='disqualification_container'>
      <StyledTitle>{t('.title')}</StyledTitle>
      {shouldDisplayContent && (
        <ContentCard data-testid='disqualification_content_card'>
          <Text.MD>{t(`.content.${reason}.paragraph_1`)}</Text.MD>
          <Text.MD>{t(`.content.${reason}.paragraph_2`)}</Text.MD>
          <Text.MD>{t(`.content.${reason}.paragraph_3`)}</Text.MD>
        </ContentCard>
      )}
    </StyledGradientWrapper>
  );
};

export default NotQualified;
